<script>
	// Stores 
	import { textSite } from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Política de privacidade';
</script>

<style type="text/sass">
@import '../sass/variables.sass'
p
	b
		color: $color-secondary
</style>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">

		<p><b>TERMO DE AUTORIZAÇÃO DE PRIVACIDADE</b></p>

		<p>Controlar Gestão Imobiliária Ltda.</p>
		
		<p>Este Termo de Autorização de Privacidade ("Termo") regula a coleta, uso e divulgação de informações pessoais pela Controlar Gestão Imobiliária ("nós", "nosso", "nossa") no contexto da utilização do aplicativo. Ao concordar com este Termo, você expressamente autoriza a coleta, processamento e uso de suas informações pessoais conforme descrito abaixo:</p>
		
		<p><b>Informações Coletadas:</b></p>
		<p>Coletaremos informações pessoais necessárias para a prestação de nossos serviços, incluindo, mas não se limitando a:</p>
		<p>
		- Nome completo<br/>
		- CPF e RG<br/>
		- Endereço de e-mail<br/>
		- Número de telefone<br/>
		- Informações de localização (se autorizado)<br/>
		- Outras informações relevantes para a prestação de serviços<br/>
		</p>
		
		<p><b>Uso das Informações:</b></p>
		<p>As informações pessoais coletadas serão utilizadas para os seguintes propósitos:</p>
		<p>
		- Prestação de serviços relacionados à gestão imobiliária<br/>
		- Comunicação sobre atualizações, promoções e eventos relevantes<br/>
		- Melhoria contínua dos nossos serviços<br/>
		</p>
		
		<p><b>Compartilhamento de Informações:</b></p>
		<p>As informações pessoais não serão compartilhadas com terceiros sem o seu consentimento, exceto quando exigido por lei.</p>
		
		<p><b>Segurança das Informações:</b></p>
		<p>Tomaremos medidas razoáveis para proteger suas informações pessoais contra acesso não autorizado ou divulgação.</p>
		
		<p><b>Seus Direitos:</b></p>
		<p>Você tem o direito de solicitar acesso, correção ou exclusão de suas informações pessoais a qualquer momento. Para exercer esses direitos, entre em contato conosco através dos meios fornecidos no aplicativo.</p>
		
		<p><b>Consentimento:</b></p>
		<p>Ao continuar a usar nosso aplicativo, você concorda com os termos deste Termo de Autorização de Privacidade.</p>
		
		<p>Este Termo de Autorização de Privacidade está sujeito a alterações, e quaisquer alterações significativas serão comunicadas a você de forma apropriada.</p>
		
		<p>Porto Alegre. 09 de janeiro de 2024.</p>
		
		<br/><br/>

	</div>
</section>